import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';

import {
  dateToTimestamp,
  timestampToDate,
  unNullifyArrays,
} from '../../utils/fieldNormalizers';

import { Trainer } from './_types';

const arrayKeys = [
  'tags',
  'reportsRole',
  'disabledTabs',
  'disabledDashboardBoxes',
  'disabledDashboardNotifications',
  'disabledEmails',
  'disabledDashboardKpis',
  'disabledDashboardCharts',
  'disabledTasks',
  'headTrainerEmails',
];

export function normalizeTrainer(trainer: any): Trainer | null {
  const camelized = camelcaseKeys(trainer);
  if (!camelized) return camelized;

  return {
    ...unNullifyArrays(camelized, arrayKeys),
    createdAt: timestampToDate(camelized.createdAt),
    updatedAt: timestampToDate(camelized.updatedAt),
    endedAt: timestampToDate(camelized.endedAt),
  } as Trainer;
}

export function denormalizeTrainer(trainer: Partial<Trainer>): any {
  const obj = decamelizeKeys(trainer, { deep: true });

  return {
    ...obj,
    created_at: dateToTimestamp(trainer.createdAt),
    updated_at: dateToTimestamp(trainer.updatedAt),
    ended_at: dateToTimestamp(trainer.endedAt),
  };
}
